import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classNames from 'classnames';
import style from './InterestSearchTag.module.css';
import { getInterestSearchTag } from "./service";


const InterestSearchTag = (props) => {
    const { history } = props;
    const [tagData, setTagData] = useState([]);

    useEffect(() => {
        (async () => {
            const { data } = await getInterestSearchTag();
            setTagData(data.list);
        })();
    }, []);

    return (
        <div className={style.wrapper}>
            <div className={style.title}>兴趣探索</div>
            <div className={style.tagWrapper}>
                {
                    tagData.map((item, index) => {
                        const { name, stress, id } = item;
                        return (
                            <span
                                key={index}
                                className={classNames([style.tag, stress && style.tagStress])}
                                onClick={() => {
                                    window.scrollTo(0,300);
                                    history.push({pathname: `/interest-search/${id}/${name}`})
                                }}
                            >
                                {name}
                            </span>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default connect()(withRouter(InterestSearchTag));
